import {useContext, useEffect, useState} from "react";
import moment from 'moment'
import AuthContext from "../contexts/AuthContext";
import {useStoreMercureTopics} from "../store/useStoreMercureTopics.ts";

/**
 *
 * @param uris
 * @param privateSubscribe
 * @param withCredentials
 * @returns {{result: {data: null, errorMessage: null, error: boolean}}}
 */
export function useMercureSubscriber(uris: array, privateSubscribe = true, withCredentials = false) {
    const {user} = useContext(AuthContext);
    const [result, setResult] = useState({
        error: false,
        errorMessage: null,
        data: null,
    });
    const topics = useStoreMercureTopics(state => state.topics);
    const addTopics = useStoreMercureTopics(state => state.addTopics);

    useEffect(() => {
        const mercureUrl = new URL(process.env.REACT_APP_MERCURE_PUBLIC_URL);

        let frontHost = process.env.REACT_APP_FRONT_HOST;

        if (frontHost.endsWith('/')) {
            frontHost = frontHost.substring(0, frontHost.length - 1)
        }

        uris.forEach((uri) => {
            if (uri.startsWith('/')) {
                uri = uri.substring(1);
            }

            let topic = `${frontHost}/${uri}`;

            if (privateSubscribe) {
                topic = `${frontHost}/${user.CodeFl}/${uri}`;
            }

            // Si le topic est déjà écouté on ne l'ajout pas dans les URLs à écouter
            if (!topics.includes(topic)) {
                mercureUrl.searchParams.append('topic', topic);
                addTopics(topic);
            }
        })

        let eventSource = null;

        // Si l'URL qui pointe vers le mercure n'a pas de topic, on écoute pas cette URL
        if (mercureUrl.searchParams.get('topic')) {
            eventSource = new EventSource(mercureUrl, {withCredentials});

            eventSource.onmessage = (event) => {
                setResult({
                    error: false,
                    errorMessage: null,
                    data: event.data !== '' ? JSON.parse(event.data) : '',
                });
            }

            eventSource.onerror = (error) => {
                setResult({
                    error: true,
                    errorMessage: error.message,
                    data: null,
                });
            }
        }


        // On ferme la connexion lorsque le composant est démonté
        return () => {
            if (eventSource instanceof EventSource) {
                eventSource.close();
            }
        }
    }, []);

    return {result};
}